import { render, staticRenderFns } from "./failure-feedback.vue?vue&type=template&id=2c94ffce&scoped=true&lang=pug"
import script from "./failure-feedback.vue?vue&type=script&setup=true&lang=js"
export * from "./failure-feedback.vue?vue&type=script&setup=true&lang=js"
import style0 from "./failure-feedback.vue?vue&type=style&index=0&id=2c94ffce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c94ffce",
  null
  
)

export default component.exports